module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-masters/deduction-codes/deduction-code-grid/deduction-code-grid.component.css
// module id = ./src/app/hrms/payroll/payroll-masters/deduction-codes/deduction-code-grid/deduction-code-grid.component.css
// module chunks = main